module.exports = __webpack_public_path__ + "img/edge.489401d4.png";